<template>
  <div>
    <el-dialog
      top="5vh"
      title="编辑详情"
      :visible.sync="dialogFormVisible"
      @close="handleToClose"
      :close-on-click-modal="false"
      width="657px"
    >
      <el-form
        :model="dataForm"
        label-position="right"
        ref="formRules"
        :rules="rules"
        label-width="100px"
        size="small"
      >
        <el-form-item
          label="学生姓名："
          prop="student_name"
        >
          <el-input
            v-model="dataForm.student_name"
            placeholder="请输入学生姓名"
            style="width: 100%"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="手机号："
          prop="student_mobile"
        >
          <el-input
            v-model="dataForm.student_mobile"
            placeholder="请输入手机号"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            style="width: 100%"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="考研年份："
          prop="apply_year"
        >
          <el-select
            v-model="dataForm.apply_year"
            placeholder="请选择考研年份"
            style="width: 100%"
            clearable
          >
            <el-option
              label="2027"
              value="2027"
            ></el-option>
            <el-option
              label="2026"
              value="2026"
            ></el-option>
            <el-option
              label="2025"
              value="2025"
            ></el-option>
            <el-option
              label="2024"
              value="2024"
            ></el-option>
            <el-option
              label="2023"
              value="2023"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="报考院校："
          prop="apply_college"
        >
          <el-select
            v-model="dataForm.apply_college"
            filterable
            placeholder="请选择"
            @change="collegeChange"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="(item, index) in $store.state.collegeList"
              :key="index"
              :label="item.name"
              :value="{ value: item.code, label: item.name}"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报考专业：">
          <el-select
            v-model="dataForm.apply_major"
            filterable
            collapse-tags
            placeholder="请选择"
            style="width: 100%"
            @change="majorChange"
          >
            <el-option
              v-for="(item,index) in majorOptions"
              :key="index"
              :label="item.allnames"
              :value="{ value: item.code, label: item.name}"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报考学院：">
          <el-select
            v-model="dataForm.apply_academy"
            placeholder="请选择"
            style="width: 100%"
            @change="$forceUpdate()"
          >
            <el-option
              v-for="(item, index) in academyOptions"
              :key="index"
              :label="item.name"
              :value="{ value: item.code, label: item.name}"
              @change="academyChange"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleToClose()">取消</el-button>
        <el-button
          type="primary"
          @click="submit('formRules')"
          slot=""
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
     <script>



import {
  seniorStudentOne,
  seniorStudentEdit
} from "@/api/distribution";
import { collegeMajorList, academyList, } from "@/api/common";



export default {
  components: {
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {
      },
      rules: {
        apply_year: [{ required: true, message: "请选择考研年份", trigger: "blur" }],
        student_name: [{ required: true, message: "请输入学生姓名", trigger: "blur" }],
        student_mobile: [{ required: true, message: "请输入学生手机号", trigger: "blur" }, { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的手机号' }],

      },
      majorOptions: [],// 专业数组
      academyOptions: [],// 学院数组
    };
  },
  mounted() {

  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
      if (val) {
        this.fetchDetail()
      }
    },
  },
  methods: {
    fetchDetail() {
      seniorStudentOne({ id: this.id }).then((res) => {
        this.dataForm = res
        if (this.dataForm.apply_college_name && this.dataForm.apply_college_code) {
          this.$set(this.dataForm, 'apply_college', {
            label: this.dataForm.apply_college_name,
            value: this.dataForm.apply_college_code,
          })
          this.fetchMajor(this.dataForm.apply_college_code)
        }
        if (this.dataForm.apply_major_name && this.dataForm.apply_major_code) {
          this.$set(this.dataForm, 'apply_major', {
            label: this.dataForm.apply_major_name,
            value: this.dataForm.apply_major_code,
          })
          this.fetchAcademy(this.dataForm.apply_college_code, this.dataForm.apply_major_code)
        }
        if (this.dataForm.apply_academy_name && this.dataForm.apply_academy_code) {
          this.$set(this.dataForm, 'apply_academy', {
            label: this.dataForm.apply_academy_name,
            value: this.dataForm.apply_academy_code,
          })
        }
      });
    },
    handleToClose() {
      this.$emit("close");
    },
    collegeChange(e) {
      this.dataForm.apply_academy = null
      this.dataForm.apply_major = null
      this.majorOptions = []
      this.academyOptions = []
      if (e) {
        this.fetchMajor(e.value)
      }
    },
    fetchMajor(college_code) {
      collegeMajorList({ college_code: college_code, isPaging: 0 }).then((res) => {
        this.majorOptions = res.list.map(v => {
          return {
            ...v,
            allnames: `（${v.code}）${v.name}`
          }
        })
      });
    },
    majorChange(e) {
      this.dataForm.apply_academy = null
      this.academyOptions = []
      if (e) {
        this.fetchAcademy(this.dataForm.apply_college.value, e.value)
      }
    },
    fetchAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyOptions = res.list || [];
      });
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          console.log('ads');
          let data = {
            id: this.dataForm.id,
            apply_year: this.dataForm.apply_year,
            student_name: this.dataForm.student_name,
            student_mobile: this.dataForm.student_mobile,
            apply_college_code: this.dataForm.apply_college ? this.dataForm.apply_college.value : "",
            apply_college_name: this.dataForm.apply_college ? this.dataForm.apply_college.label : "",
            apply_major_code: this.dataForm.apply_major ? this.dataForm.apply_major.value : "",
            apply_major_name: this.dataForm.apply_major ? this.dataForm.apply_major.label : "",
            apply_academy_code: this.dataForm.apply_academy ? this.dataForm.apply_academy.value : "",
            apply_academy_name: this.dataForm.apply_academy ? this.dataForm.apply_academy.label : "",
          }
          seniorStudentEdit(data).then((res) => {
            this.$message.success('操作成功')
            this.$emit('submit')
            this.handleToClose()
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    academyChange(e) {
      console.log(e);
    },


  },
};
      </script>
      
      <style lang="less" scoped>
</style>